import React from 'react';
import Select from 'react-select';
import { Col, Form as BsForm, Row, Table } from 'react-bootstrap';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

// W-0654 — Combo GE (Status='A', vem do backend) + grid de departamentos do GE.
// Paridade UAlteraDepto.pas: combo GE + lookup cdDepto. Depto NÃO tem busca por código/apelido
// (ao contrário do W-0651/Conta) — lookup direto ordenado por código.
const SelecionarDepartamento = ({
  opcoesGe,
  codigoGrupoEmpresa,
  onSelecionarGe,
  departamentos,
  carregando,
  departamentoSelecionado,
  onSelecionarDepartamento,
}) => {
  return (
    <>
      <Row>
        <Col xs={12} md={6}>
          <BsForm.Label className="small mb-1">Grupo de Empresa</BsForm.Label>
          <Select
            options={opcoesGe}
            value={opcoesGe.find((o) => o.value === codigoGrupoEmpresa) || null}
            onChange={(opt) => onSelecionarGe(opt ? opt.value : '')}
            styles={customStyles}
            components={{ DropdownIndicator }}
            placeholder="Selecione o Grupo de Empresa"
            isClearable
            noOptionsMessage={() => 'Nenhum grupo de empresa'}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col xs={12}>
          <div style={{ maxHeight: 320, overflowY: 'auto' }}>
            <Table hover size="sm" responsive className="mb-0">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descrição</th>
                  <th>Responsável</th>
                  <th>Grupo</th>
                </tr>
              </thead>
              <tbody>
                {departamentos.length === 0 && (
                  <tr>
                    <td colSpan={4} className="text-center text-muted small py-3">
                      {carregando
                        ? 'Carregando...'
                        : 'Nenhum departamento encontrado.'}
                    </td>
                  </tr>
                )}
                {departamentos.map((depto) => (
                  <tr
                    key={`${depto.codigo}`}
                    onClick={() => onSelecionarDepartamento(depto)}
                    style={{ cursor: 'pointer' }}
                    className={
                      departamentoSelecionado &&
                      departamentoSelecionado.codigo === depto.codigo
                        ? 'table-primary'
                        : ''
                    }
                  >
                    <td>{depto.codigo}</td>
                    <td>{depto.descricao}</td>
                    <td>{depto.responsavel != null ? depto.responsavel : '-'}</td>
                    <td>{depto.grupo != null ? depto.grupo : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SelecionarDepartamento;
